import React from 'react';
import { useTranslation } from 'react-i18next';
import PriceTag from '../ui/PriceTag';

export default function MenuItemRow({
  item,
  currency,
  getImageUrl,
  togglingId,
  outOfStockReason,
  onReasonChange,
  onSaveReason,
  onToggleAvailability,
  onEdit,
  onManageAddons,
  onSchedule,
  onDelete,
}) {
  const { t } = useTranslation();
  const isAvailable = item.is_available === 1 || (item.is_available !== 0 && item.is_available !== false);
  const hasAddons = item.hasAddons || (Array.isArray(item.addons) && item.addons.length > 0) || item.has_addons || (typeof item.addons_count === 'number' && item.addons_count > 0);

  return (
    <div className="menu-item-card" style={{ opacity: isAvailable ? 1 : 0.85 }}>
      <div className="item-image-wrap">
        <span className={`item-status-badge ${isAvailable ? 'available' : 'unavailable'}`}>
          {isAvailable ? t('admin.menuItem.available', 'Available') : t('admin.menuItem.unavailable')}
        </span>
        {item.image_url ? (
          <img src={getImageUrl(item.image_url)} alt={item.name} className="item-image" />
        ) : (
          <div className="item-image-placeholder">🍽️</div>
        )}
      </div>
      <div className="item-info">
        <h4>{item.name}</h4>
        <p>{item.description}</p>
        <div className="item-info-row">
          <span className="item-price">
            <PriceTag amount={item.price} currency={currency} size="sm" color="inherit" style={{ fontSize: 'inherit', fontWeight: 'inherit' }} />
          </span>
          {item.section && <span className="item-section-pill">{item.section}</span>}
        </div>
        {hasAddons && (
          <div className="item-addons-indicator">
            🧩 {t('admin.addons.hasAddons', 'Has add-ons')}
          </div>
        )}
        {!isAvailable && (
          <input
            type="text"
            className="form-input form-input-small"
            placeholder={t('admin.menuItem.reasonPlaceholder', 'Reason (optional)')}
            value={outOfStockReason ?? item.out_of_stock_reason ?? ''}
            onChange={(e) => onReasonChange(item.id, e.target.value)}
            onBlur={(e) => onSaveReason(item.id, e.target.value.trim())}
            style={{ marginTop: '0.5rem', padding: '0.4rem 0.6rem', fontSize: '0.875rem' }}
          />
        )}
        {item.schedules && item.schedules.length > 0 && (
          <div className="schedule-indicator" style={{ marginTop: '0.5rem', fontSize: '0.8rem', color: '#6b7280' }}>
            {item.schedules.length} {t('admin.schedule.activeCount', 'schedule(s) active')}
          </div>
        )}
      </div>
      <div className="item-actions">
        <div className="item-availability-toggle">
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={isAvailable}
              onChange={() => onToggleAvailability(item)}
              disabled={togglingId === item.id}
            />
            <span className="toggle-slider" />
            <span className="toggle-label">
              {isAvailable ? t('admin.menuItem.available', 'Available') : t('admin.menuItem.outOfStock', 'Out of Stock')}
            </span>
          </label>
        </div>
        <div className="item-action-buttons">
          <button
            type="button"
            className="item-action-btn item-action-btn-deactivate"
            onClick={() => onToggleAvailability(item)}
            disabled={togglingId === item.id}
            title={isAvailable ? t('admin.menuItem.setUnavailable') : t('admin.menuItem.setAvailable')}
          >
            {togglingId === item.id ? '…' : isAvailable ? t('admin.menuItem.deactivate', 'Deactivate') : t('admin.menuItem.activate', 'Activate')}
          </button>
          <button type="button" className="item-action-btn edit" onClick={() => onEdit(item)} title={t('common.edit')}>✏️</button>
          <button type="button" className="item-action-btn addons" onClick={() => onManageAddons(item)} title={t('admin.addons.manageAddons')}>🧩</button>
          <button type="button" className="item-action-btn schedule" onClick={() => onSchedule(item)} title={t('admin.schedule.manageTitle', 'Schedule')}>🕒</button>
          <button type="button" className="item-action-btn delete" onClick={() => onDelete(item.id)} title={t('common.delete')}>🗑️</button>
        </div>
      </div>
    </div>
  );
}
